import { render, staticRenderFns } from "./CollapsablePanel.vue?vue&type=template&id=e28109ca&scoped=true&"
import script from "./CollapsablePanel.vue?vue&type=script&lang=js&"
export * from "./CollapsablePanel.vue?vue&type=script&lang=js&"
import style0 from "./CollapsablePanel.vue?vue&type=style&index=0&id=e28109ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28109ca",
  null
  
)

export default component.exports